/* eslint-disable linebreak-style */
export const BASEURL = 'https://api.floodquotes.us/v1/';
export const CONSTANTS = 'config/get-instance';
export const APPLICATION = 'application/initiate-application';
export const SUBMIT_APPLICATION = 'application/submit-application';
export const MAKE_PAYMENT = 'payment/make-payment';
export const PRE_BIND_APPLICATION = 'application/quote/pre-bind';
export const SUBMIT_FINAL_APPLICATION = 'application/quote/submit-final-application';
export const BIND_APPLICATION = 'application/quote/bind';
export const AGENCYAPI = 'company/list?businessType=AGENCY';
export const APPLICATIONS = 'application/application-list';
export const ADMIN_APPLICATIONS = 'distribution/application-list';
export const PAYMENT_DETAILS = 'payment/quote-details';
export const CURRENT_APPLICATION = '/application/get-single-application';
export const GET_APP_DATA = 'application/quote/get-app-data';
export const GET_CURRENT_APP_DATA = 'application/quote/get';
export const QUOTE_LIST = 'application/get-quote-list';
export const ACTIVE_SCREEN = 'application/quote/active-screen';
export const SIGNIN = 'onboarding/sign-in';
export const SIGNUP = 'onboarding/sign-up';
export const UPLOAD_URL = 'config/files/upload-url';
export const UPLOAD_POLICY = 'distribution/upload-policy';
export const FORGOTPASSWORD = 'onboarding/forgot-password';
export const VERIFYUSEREMAIL = 'onboarding/verify-user-email';
export const SETUSERPASSWORD = 'onboarding/set-user-password';
export const COPYAPPLICATION = 'application/copy-application-link';
export const SCHEDULEREMAINDER = 'application/add-schedule-reminder';
export const VERIFYEMAILOTP = 'onboarding/verify-email-otp';
export const RESENDOTP = 'onboarding/resend-verification-otp';
